/* 此文件由@huyafed/source-codegen自动生成，请不要修改文件任何内容！*/

import AppLive from './App-live.png'
import App41 from './App4-1.png'
import App42 from './App4-2.png'
import bg from './bg.png'
import hyLogo from './hy-logo.png'
import iconApp from './icon-app.png'
import iconClose from './icon-close.png'
import iconDown from './icon-down.png'
import iconDown1 from './icon-down1.png'
import iconMac from './icon-mac.png'
import iconMike from './icon-mike.png'
import iconMore from './icon-more.png'
import iconRight from './icon-right.png'
import iconWindow from './icon-window.png'
import iconWindow1 from './icon-window1.png'
import PCLive from './PC-Live.png'
import PC1 from './PC1.png'
import PC2 from './PC2.png'
import PC3 from './PC3.png'
import PC41 from './PC4-1.png'
import PC42 from './PC4-2.png'
import qrcode_live from './qrcode_live.png'
import qrcode from './qrcode.png'

export default {
  AppLive,
  App41,
  App42,
  bg,
  hyLogo,
  iconApp,
  iconClose,
  iconDown,
  iconDown1,
  iconMac,
  iconMike,
  iconMore,
  iconRight,
  iconWindow,
  iconWindow1,
  PCLive,
  PC1,
  PC2,
  PC3,
  PC41,
  PC42,
  qrcode_live,
  qrcode,
}
